/**
 * Card Component
 * ==============
 * Container component with optional header.
 */

import { clsx } from 'clsx'

interface CardProps {
  children: React.ReactNode
  className?: string
}

interface CardHeaderProps {
  title: string
  description?: string
  action?: React.ReactNode
}

export function Card({ children, className }: CardProps) {
  return (
    <div className={clsx('bg-white dark:bg-gray-800 rounded-xl shadow-sm border dark:border-gray-700 transition-colors', className)}>
      {children}
    </div>
  )
}

export function CardHeader({ title, description, action }: CardHeaderProps) {
  return (
    <div className="px-6 py-4 border-b dark:border-gray-700 flex items-center justify-between">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h2>
        {description && (
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">{description}</p>
        )}
      </div>
      {action && <div>{action}</div>}
    </div>
  )
}

export function CardContent({ children, className }: CardProps) {
  return <div className={clsx('p-6', className)}>{children}</div>
}
